import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import PeopleIcon from "@mui/icons-material/People";
import LocalTaxiIcon from "@mui/icons-material/LocalTaxi";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import { useNavigate } from "react-router-dom";

export default function DashboardCard({ label, sx, c1, c2, nav, role, count }) {
  const navigate = useNavigate();
  return (
    <Card
      onClick={() => navigate(`/Dashboard/${nav}`, { state: { role: role } })}
      sx={{
        ...sx,
        m: 2,
        background: `linear-gradient(to right, ${c1}, ${c2})`,
        borderRadius: 2,
        boxShadow: 3,
        color: "white",
        cursor: "pointer",
      }}
    >
      <CardContent>
        <Stack spacing={3}>
          <Stack
            direction="row"
            sx={{ alignItems: "flex-start", justifyContent: "space-between" }}
            spacing={3}
          >
            {/* Additional Text Section */}
            <Stack className="gap-2">
              <Typography variant="h6" fontFamily="Poppins">
                {label}
              </Typography>
              <div className="font-Poppins text-2xl font-medium">
                {label === "Wallet Transaction Report" && `₹`} {count}
              </div>
              <Typography variant="body2" fontFamily="Poppins">
                View Details &gt;
              </Typography>
            </Stack>

            {label === "Total Bookings" ? (
              <>
                <LocalTaxiIcon style={{ fontSize: 60 }} />
              </>
            ) : label === "Wallet Transaction Report" ? (
              <>
                <AccountBalanceWalletIcon style={{ fontSize: 60 }} />
              </>
            ) : (
              <>
                <PeopleIcon style={{ fontSize: 60 }} />
              </>
            )}
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
